export const DEFAULT_PAGE_SIZE = 25;

export const STATUS_OPTIONS = [
  { label: 'Status', value: '' },
  { label: 'Available', value: 'AVAILABLE' },
  { label: 'Assigned', value: 'ASSIGNED' },
];

export const TABLE_HEADING = {
  column: [
    'ID',
    'Territory Manager',
    'TM Contact Number',
    'Store',
    'Store Name',
    'Gift Allocation',
    'Secret Code',
    'Unique Ref',
    'Status',
    'Created At',
    'Assigned At',
  ],
};

export const NOT_FOUND_MESSAGE = 'No data found';

export const INITIAL_FILTERS = {
  customer: '',
  customerName: '',
  secretCode: '',
  status: '',
};

export const INITIAL_STATE = {
  campaignCodes: [],
  currentPage: 0,
  totalPages: 0,
  loading: false,
  fetchError: '',
  isSearching: false,
  filters: INITIAL_FILTERS,

  uploadedFile: null,
  uploadLoading: false,
  uploadError: null,
  uploadResult: null,

  showDrawer: false,
  drawerData: null,

  showDownloadModal: false,
  downloadFilters: {
    status: '',
    startDate: null,
    endDate: null,
  },
  downloadingCSV: false,
};

export const ERROR_CODES = {
  ACCESS_DENIED: 'ACCESS_DENIED',
  INVALID_STATUS: 'INVALID_STATUS',
  SERVER_ERROR: 'SERVER_ERROR',
};

export const ERRORS = {
  [ERROR_CODES.ACCESS_DENIED]:
    "You don't have permission to view campaign codes. This requires the Thyaga Administrator role.",
  [ERROR_CODES.INVALID_STATUS]:
    'Status filter must be either AVAILABLE or ASSIGNED.',
  [ERROR_CODES.SERVER_ERROR]:
    'Something went wrong on the server. Please try again.',
};

export const DEFAULT_FETCH_ERROR_MESSAGE =
  'Oops, something went wrong. Please try again.';

export const getCampaignCodesErrorMessage = (rawMessage) => {
  if (!rawMessage) {
    return DEFAULT_FETCH_ERROR_MESSAGE;
  }
  return ERRORS[rawMessage] || DEFAULT_FETCH_ERROR_MESSAGE;
};

export const hasActiveFilters = (filters) =>
  Object.values(filters).some((value) => value && value.trim() !== '');
